(function () {

  const FREEBIE_VARIANT_IDS = [
    46620614131970,
    46620630122754,
    46620630155522,
    46620520874242,
    46620523331842,
    46620523364610,
    46620462579970,
    46620462612738,
    46620462645506,
    46620230910210,
    46620282814722,
    46620445769986,
    46620678291714,
    46620678324482,
    46620678357250,
    46620678390018,
    46620678422786,
    46620678455554,
    46620678488322
  ];

  // 👇 Add freebie product IDs here (alternative to variant IDs)
  const FREEBIE_PRODUCT_IDS = [

  ];

  const HIDE_GIFT_BLOCK_PRODUCT_IDS = [
    9200926949634,  9349145493762
  ];

  // ✅ Helper: match freebie by variant ID or product ID
  function isFreebie(item) {
    return FREEBIE_VARIANT_IDS.includes(item.variant_id) ||
           FREEBIE_PRODUCT_IDS.includes(Number(item.product_id));
  }

  const styleTag = document.createElement('style');
  styleTag.id = 'freebie-block-style';
  document.head.appendChild(styleTag);

  let isChecking = false;
  let lastCartState = null;

  function lockFreebieQuantityControls(cart) {
    const allQtyButtons = document.querySelectorAll('.xb_slide_cart_product_button_quantity');

    cart.items.forEach((item, index) => {
      const minusBtn = allQtyButtons[index * 2];
      if (!minusBtn) return;

      const qtyWrapper = minusBtn.closest('.xb-flex.xb-gap-1');
      if (!qtyWrapper) return;

      if (isFreebie(item)) {
        qtyWrapper.style.display = 'none';
      } else {
        qtyWrapper.style.display = '';
      }
    });
  }

  function toggleGiftBlock(cart) {
    const hasHideProduct = cart.items.some(item =>
      HIDE_GIFT_BLOCK_PRODUCT_IDS.includes(Number(item.product_id))
    );

    const hasOtherProduct = cart.items.some(item =>
      !HIDE_GIFT_BLOCK_PRODUCT_IDS.includes(Number(item.product_id)) &&
      !isFreebie(item)
    );

    const shouldHide = hasHideProduct && !hasOtherProduct;

    styleTag.textContent = shouldHide
      ? '.xb_slide_cart_upsell { display: none !important; }'
      : '';
  }

  function disableUpsellButtonsIfFreebieExists(forceCheck = false) {
    if (isChecking) return;
    isChecking = true;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const cartSignature = JSON.stringify(
          cart.items.map(item => item.variant_id)
        );

        if (!forceCheck && cartSignature === lastCartState) {
          isChecking = false;
          return;
        }

        lastCartState = cartSignature;

        toggleGiftBlock(cart);

        const hasFreebie = cart.items.some(item => isFreebie(item));

        const buttons = document.querySelectorAll(
          '.xb_slide_cart_upsell_button_add_to_cart'
        );

        buttons.forEach(btn => {
          if (hasFreebie) {
            if (btn.dataset.freebieDisabled === "true") return;
            btn.dataset.freebieDisabled = "true";
            btn.disabled = true;
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.6';
            const textSpan = btn.querySelector('span span');
            if (textSpan) textSpan.textContent = 'FREEBIE ADDED';
          } else {
            btn.dataset.freebieDisabled = "false";
            btn.disabled = false;
            btn.style.pointerEvents = '';
            btn.style.opacity = '';
          }
        });

        lockFreebieQuantityControls(cart);

        isChecking = false;
      })
      .catch(() => {
        isChecking = false;
      });
  }

  const cartObserver = new MutationObserver(() => {
    disableUpsellButtonsIfFreebieExists(true);
  });

  function attachObserver() {
    const cartDrawer =
      document.querySelector('#xb-slide-cart') ||
      document.querySelector('.xb-slide-cart') ||
      document.querySelector('[data-slide-cart]');

    if (cartDrawer) {
      cartObserver.observe(cartDrawer, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    disableUpsellButtonsIfFreebieExists();
    attachObserver();
  });

  document.addEventListener('cart:updated', () => disableUpsellButtonsIfFreebieExists(true));
  document.addEventListener('cart:refresh', () => disableUpsellButtonsIfFreebieExists(true));

  setInterval(disableUpsellButtonsIfFreebieExists, 5000);

})();